export class ImageEffect {
  name: string = '';
  image: string = '';
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/image-effect.model.ts